<template>
  <div class="smart-venues">
    <HeaderStyles1>
      <!--      <h1 slot="title" v-html="$t('smart-venues-head-h1')"></h1>-->
      <!--      <p slot="detail" v-html="$t('smart-venues-head-small')"></p>-->
      <!--      <b-img class="platform-title-img" slot="image" src="../assets/imgs/head-img-smart-venues.png" alt="" />-->
    </HeaderStyles1>

    <b-container fluid="xl" class="main-content">
      <section class="page-section">
        <h1 class="section-title">涂色精灵（宝宝涂色精灵）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_tuse_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_tuse_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_tuse_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_tuse_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    涂色精灵（宝宝涂色精灵）为大家提供了多种涂色场景，有人物，动物，水果等，让大家乐趣更多。
                    <br/>
                    涂色精灵（宝宝涂色精灵）功能:
                    <br/>
                    【多样涂色】提供了多种人物，动物植物，水果等序列的涂色场景，场景多样乐趣更多。
                    <br/>
                    【快速涂色】操作简单，选择颜色，随意涂色，颜色色板可以自行涂各种颜色。
                    <br/>
                    【作品列表】可以保存查看自己的涂色作品。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/tuse.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">拼图精灵（宝宝拼图精灵）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_pintu_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_pintu_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_pintu_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_pintu_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    拼图精灵（宝宝拼图精灵）为大家提供了多种益智拼图场景卡片，有人物，宠物，美食，场景等，让大家更好的放松。
                    <br/>
                    拼图精灵（宝宝拼图精灵）功能:
                    <br/>
                    【拼图列表】提供了多种人物，宠物，美食，场景序列的拼图列表。
                    <br/>
                    【拼图】用户可以通过拖动拼图卡片进行拼接图片。
                    <br/>
                    【拼图自定义难易】支持自行按行，按列排版，自行设置拼图卡片数量，拼图难易度。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/pintu.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">绘画精灵</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_paint_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_paint_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_paint_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_paint_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    绘画精灵是一款简单绘画绘图、笔刷绘画绘图，跟随图形绘画绘图的绘画软件。
                    <br/>
                    绘画精灵功能:
                    <br/>
                    【简单绘画】操作简单，快速上手，提供画板，有钢笔，铅笔，蜡笔多种笔刷，红黑白等多种颜色，可调整笔刷粗细，可使用橡皮擦擦除。
                    <br/>
                    【笔刷绘画】笔刷绘图可选择多个图层绘制，可以选择背景图片，添加多种形状图形，贴图，颜色，笔刷等高级玩法。
                    <br/>
                    【跟图绘画】跟图绘图可以帮助初学者更快速的学习临摹。
                    <br/>
                    【形状绘画】帮助初学者对形状有更深刻的认真。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/paint.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">记账有宝</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/acount_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/acount_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/acount_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/acount_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    记账有宝，一款轻便，快速，简洁的记账好帮手！
                    <br/>
                    便捷好用的生活记账本，适用于日常生活，娱乐购物，家庭账本，人情往来，工资奖励，随手记账等，再也不担心钱花哪了，简洁的记账流程，让您随时随地掌握资金流向。
                    <br/>
                    记账有宝功能:
                    <br/>
                    【3秒钟记账】极简的操作流程，让您3秒钟快速完成一笔记账。
                    <br/>
                    【数据安全】数据只存本地，保护个人隐私。
                    <br/>
                    【账单分析】一目了然的图表，帮您快速分析消费情况，及时调整支出。
                    <br/>
                    【记账日历】记账记录可按日切换查看，快速查账补漏。
                    <br/>
                    【自定义类别】自定义类别，满足更多需求。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/acount.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">轻拍睡眠</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/icon_qingpai_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/icon_qingpai_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/icon_qingpai_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/icon_qingpai_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    轻拍睡眠，更有效的助眠软件，精选多场景助眠音频，助您更好的入睡；通过有节律的敲打木鱼，倾听纯音，让心情舒畅开，达到静心解压效果。
                    <br/>
                    主要功能如下：
                    <br/>
                    【助眠音频】精选有利于睡眠的多种场景纯音乐，页面简洁，操作简单，适合更多的人群，助您更好的入睡。
                    <br/>
                    【轻拍哄睡】自定义助眠哄睡设置，可以设置是否自动播放，播放时长。
                    <br/>
                    【静心解压】有节律的敲打木鱼，可设置是否自动敲打，可以切换不同皮肤，背景纯音乐，更好的放松自己。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/qingpai.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">电子烟花鞭炮</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bianpao_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bianpao_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bianpao_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bianpao_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    电子烟花鞭炮，有趣的数字烟花鞭炮，含有多种场景烟花，鞭炮效果。
                    <br/>
                    主要功能如下：
                    <br/>
                    【电子烟花】选择烟花场景，播放烟花，五彩纷呈，绚丽夺目。
                    <br/>
                    【电子鞭炮】选择鞭炮场景，播放鞭炮，鞭炮个个响亮，回味无穷。
                    <br/>
                    【一炷香】每天点一炷香，快乐翻倍，可以设置背景音乐，一炷香时长，是否自动燃香。
                    <br/>
                    【快乐PK】快乐指数排行榜，PK快乐乐趣多。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/bianpao.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">视频剪辑多多</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/vedio_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/vedio_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/vedio_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/vedio_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    视频剪辑多多，一款更全能好用额视频剪辑工具，轻松剪出美好生活。
                    <br/>
                    视频剪辑多多功能:
                    <br/>
                    【视频剪辑】可以自由按比例裁剪视频，提取音频，压缩视频，设置封面，配音，增加丰富的特效，多风格的滤镜，添加多样式的贴纸，自定义文字，拼接视频
                    <br/>
                    【视频拼接压缩】可以对视频进行压缩和拼接多个视频，然后进行压缩。
                    <br/>
                    【视频转GIF】把视频转换成自定义秒数的GIF。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/vedio.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">美颜拍照相机</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/cramera_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/cramera_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/cramera_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/cramera_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    美颜拍照相机是你喜爱的照片编辑软件，包含美颜拍照，丰富的照片编辑功能，自拍滤镜，自动美颜，多种多样贴纸文本，前后背景等，让您更简单快速制作出满意的图片效果
                    <br/>
                    美颜拍照相机功能:
                    <br/>
                    【拍摄编辑】丰富的自拍滤镜，自动美颜，多种多样照片滤镜，裁剪，调整比例自动，1:1,3:4,5:4,9:16等， 模糊、马赛克，改变照片背景，贴纸种类丰富，字体创造，照片涂鸦功能，照片画画，调整色彩，多种特效，照片画中画。
                    <br/>
                    【照片编辑】多种多样照片滤镜，裁剪，调整比例自动，1:1,3:4,5:4,9:16等， 模糊、马赛克，改变照片背景，贴纸种类丰富，字体创造，照片涂鸦功能，照片画画，调整色彩，多种特效，照片画中画。
                    <br/>
                    【照片拼贴】可将多达9张的照片进行照片组合，组合布局模板种类多样，多种多样照片滤镜，调整比例自动，1:1,3:4,5:4,9:16等， 模糊、马赛克，改变照片背景，贴纸种类丰富，字体创造。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/camera.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">轻记课程表</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/curriculum_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/curriculum_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/curriculum_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/curriculum_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    轻记课程表，让您更清晰查看每日课程
                    <br/>
                    轻记课程表功能:
                    <br/>
                    【清晰课程表】更直观的查看每日的课程表，支持是否显示周末，是否显示节次，还可以快速切换周
                    <br/>
                    【快速添加】更快速添加课程，快速选择周，节次，教室
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/curriculum.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title"> 降温宝（降温测温精灵）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/cooler_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/cooler_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/cooler_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/cooler_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    降温宝（降温测温精灵），一键真降温，超强省电
                    <br/>
                    降温宝（降温测温精灵）功能:
                    <br/>
                    【降温】一键降温，不再为手机发贴烦恼
                    <br/>
                    【高温预警】高温预警，枕边充电也安心
                    <br/>
                    【电池省电】一键省电，智能监测手机温度，电量，电压，健康状态
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/cooler_official_release.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">电子拇指琴（指尖拇指琴）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_kalinba_5.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_kalinba_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_kalinba_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_kalinba_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    拇指琴(或称“卡林巴琴”英语名称: kalimba) 是一种非洲具有民族特色的民族乐器。电子拇指琴（指尖拇指琴）是专门为拇指琴爱好者打造的软件。软件内置拇指琴真实的音色，界面简洁，使用简单，能够轻松演奏各种曲子。
                    <br/>
                    主要功能有:
                    <br/>
                    【调音】支持10,17,21键调音和手动|自动调音模式
                    <br/>
                    【弹奏】支持10,17,21键弹奏模式
                    <br/>
                    【琴谱】多种流行，复古，经典琴谱
                    <br/>
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/kalinba.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">天天数日子（数日子）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_distanceday_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_distanceday_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_distanceday_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_distanceday_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                   天天数日子（数日子），一款帮您记录和管理各种重要日子和记录重要事情的生活小工具。
                    <br/>
                    主要功能有:
                    <br/>
                    【倒数日】新建重要日子倒数日事件，重要日子提醒。
                    <br/>
                    【备忘录】便捷记录重要事情，不遗忘。
                    <br/>
                    【历史今日】历史今日发生的重大事件，更好的了解历史
                    <br/>
                    【今日美句】治愈心灵，饱满过好每一天
                    <br/>
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/distanceday.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">指尖木鱼</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_muyu_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_muyu_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_muyu_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_muyu_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    指尖木鱼，敲木鱼，敲您所想，敲您所念；念珠一念，烦恼全抛；颂钵冥想，身心治愈；虔诚烧香，心想事成
                    <br/>
                    主要功能有:
                    <br/>
                    【敲木鱼】按节律敲打木鱼，用于定神,可设置自动敲打，是否播放敲木鱼音，背景禅音
                    <br/>
                    【念佛珠】按节律念佛珠，用于静心,可设置自动滚念，是否播放滚念佛珠音，背景禅音
                    <br/>
                    【颂钵治愈】按节律敲打颂钵，用于冥想,可设置自动敲打，是否播放敲打颂钵音，背景禅音
                    <br/>
                    【一炷香】烧一炷香，用于虔诚祈祷，可设置自动烧香，一炷香时长，背景禅音
                    <br/>
                    【功德排行榜】每日积攒，心诚则灵，功德pk
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/muyu.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">开心计步（健身有宝|健身训练）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_happy_5.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_happy_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_happy_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_happy_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    开心计步（健身有宝|健身训练），每天走一走，健身训练，呼吸训练，健康运动，调整身心健康。主要功能有
                    <br/>
                    主要功能有:
                    <br/>
                    【轻松计步】轻松精准计步，可无网络计步，可云存储，统计分析每日走路步数，消耗卡路里，运动距离。
                    <br/>
                    【健身训练】精选健身训练课程，2分钟锻炼课程，快速瘦身瘦脸课程。
                    <br/>
                    【呼吸训练法】精选多种呼吸训练法，比如有平复情绪，缓解压力的，有加速代谢，排毒收费减肥的，有锻炼咽喉肌肉，减少呼噜的。
                    <br/>
                    【运动排行榜】通过对比评估自身运动量，知道自己所处档次。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/happysport.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">人人答题</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_question_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_question_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_question_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_question_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    人人答题挑战，含有观察力，记忆力，想象力多种专项题目挑战，让您在答题中不知不觉提高自身能力，温习旧知识。
                    <br/>
                    人人答题功能:
                    <br/>
                    【想象力挑战】包含看图猜成语，过关解析，学习温习祖国上下五千年文化，上千题目关卡，等您来答。
                    <br/>
                    【观察力挑战】包含看图找不同，在寻找不同中提升自身专注力，观察力，上千题目关卡，等您挑战。
                    <br/>
                    【记忆力挑战】包含听曲猜名，磨炼您的听力和记忆力，上千题目关卡，等您来答。
                    <br/>
                    【脑力小卖部】购买脑力，答题通关无障碍。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">天天早睡打卡</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/sheep_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/sheep_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/sheep_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/sheep_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    天天早睡打卡，坚持每日早睡打卡的习惯养成软件，每天坚持一点点，培养自律好习惯，改变，从现在开始
                    <br/>
                    天天早睡打卡功能:
                    <br/>
                    【每日打卡】每日20点到23点打卡，养成早睡习惯
                    <br/>
                    【打卡日历】日历展示你往日打卡记录，统计累计打卡，连续打卡天数
                    <br/>
                    【分享打卡】分享打卡，邀请好友共同监督
                    <br/>
                    【每日美句】每日美句，治愈心灵
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/sheep.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">每日喝水提醒（指尖喝水提醒）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/water_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/water_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/water_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/water_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/water_des_5.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    每日喝水提醒（指尖喝水提醒），一款简约的提醒喝水饮水软件，是大家多喝水，健康饮水和按时喝水的好帮手，为您提供提醒的喝水提醒，喝水记录，喝水分享，设立目标和喝水PK的功能，还具有喝水的历史数据统计，生成对应的喝水报告
                    <br/>
                    每日喝水提醒（指尖喝水提醒）功能:
                    <br/>
                    【每日喝水】准确记录喝水饮水数据，云端存储，数据不丢失。
                    <br/>
                    【喝水提醒】准时提醒每次喝水不错过，可以自己自定义喝水时间，喝水容量。
                    <br/>
                    【分享打卡】分享喝水，邀请好友拥有更健康的身体
                    <br/>
                    【喝水排行】pk全国喝水量
                    <br/>
                    【每日美句】每日美句，治愈心灵
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/water.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">人人走路计步器（人人计步器）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_duoduop_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_duoduop_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_duoduop_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_duoduop_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    人人走路计步器（人人计步器），主要功能模块有：计步，活动挑战，运动数据。
                    <br/>
                    <br/>
                    【计步】简约精准计步，可无网络计步。
                    <br/>
                    【活动挑战】活动趣味新颖，可以挑战各种虚拟路线，重走长征，公里赛。
                    <br/>
                    【运动数据】记录每日运动数据，身体健康状态。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/pedometer.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">天天早起打卡（指尖早起打卡）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/getup_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/getup_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/getup_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/getup_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    天天早起打卡（指尖早起打卡），坚持每日打卡的习惯养成软件，每天坚持一点点，告别拖延症，培养自律好习惯，改变，从现在开始
                    <br/>
                    天天早起打卡（指尖早起打卡）功能:
                    <br/>
                    【每日打卡】每日5点到8点打卡，养成早起习惯
                    <br/>
                    【打卡日历】日历展示你往日打卡记录，统计累计打卡，连续打卡天数
                    <br/>
                    【分享打卡】分享打卡，邀请好友共同监督
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.kc668.store/apk/getup_official_release.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
    </b-container>
  </div>
</template>

<script>

import HeaderStyles1 from '../components/HeaderStyles3.vue'
export default {
  name: 'SmartVenues',
  components: {
    HeaderStyles1
  },
  data () {
    return {

    }
  },
  mounted () {
    document.title = '产品专区'
  }
}
</script>

<style scoped lang="scss">
  .smart-venues {
    overflow-x: hidden;
    .platform-title-img {
      max-width: 50%;
      bottom: 30px;
    }

    .page-section {
      margin-top: 90px;
      margin-bottom: 90px;

      .section-title {
        font-size: 34px;
        font-weight: 700;
        color: #000000;
        margin-bottom: 60px;
      }
    }

    .btn {
      padding: 12px 58px;
      font-size: 18px;
      font-weight: 600;
      border: 1px solid #333333;
      border-radius: 28px;
      color: #333333;
      outline: 0 none;
      text-transform: capitalize;
      transition: .3s;
      -webkit-border-radius: 28px;
      -moz-border-radius: 28px;
      -ms-border-radius: 28px;
      -o-border-radius: 28px;
    }
    .btn:hover{color: #333333;background: #ffffff;}
    .btn:focus{color: #333333;background: #ffffff;}
    .section-1-content {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }
    .section-1-title {
      font-size: 24px;
      font-weight: 700;
      color: #39239e;
    }
    .section-1-item {
      width: 200px;
      height: 230px;
      border-radius: 4px;
      background: #6c63ff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #ffffff;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      img {
        margin-bottom: 20px;
        width: 36px;
      }
    }
    .section-1-arrow {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      > span {
        font-size: 16px;
        margin-top: 20px;
        color: #39239E;
        font-weight: bold;
      }
    }
    .arrow-top-wrap {
      .arrow-top {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 64px 30px 64px;
        border-color: transparent transparent #39239e transparent;
      }
    }

    .section-2-text {
      padding: 20px;
      font-size: 22px;
      font-weight: bold;
      line-height: 1.4;
      color: #ffffff;
      background-color: #6C63FF;
    }

    .section-head-img {
      width: 200px;
    }
    .section-list-item {
      display: inline-flex;
      padding: 20px;

      .section-list-item-img {
        height: 60px;
        width: 60px;
        object-fit: contain;
        align-self: flex-start;
        margin-right: 20px;
      }
      .section-list-item-content {
        flex: 1;
        display: flex;
        flex-direction: column;

        h4 {
          font-size: 16px;
          font-weight: bold;
          line-height: 1.5;
        }
        p {
          font-size: 16px;
          line-height: 1.4;
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .smart-venues {
      .page-section {

        .section-title {
          font-size: 18px;
          text-align: center;
          margin-bottom: 30px;
        }

        .section-1-title {
          font-size: 14px;
        }
        .arrow-top-wrap {
          transform: translateY(-25px);
          .arrow-top {
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 19.5px 9px 19.5px;
            border-color: transparent transparent #39239e transparent;
          }
        }
        .section-1-content {
          margin-top: 0;
        }

        .section-1-item {
          height: 90px;
          img {
            width: 12px;
            margin-bottom: 10px;
          }
          span {
            font-size: 10px;
            transform: scale(0.8);
            height: 30px;
          }
        }
        .section-1-arrow {
          padding: 0;

          span {
            font-size: 10px;
            transform: scale(0.5);
          }
        }

        .section-2-text {
          padding: 15px;
          font-size: 16px;
        }
      }

      .section-head-img {
        margin-bottom: 20px;
        width: 90px;
      }
      .section-list-item {
        padding: 10px;

        .section-list-item-img {
          height: 30px;
          width: 30px;
          margin-right: 10px;
        }
        .section-list-item-content {
          h4 {
            font-size: 12px;
          }
          p {
            font-size: 12px;
          }
        }
      }
    }
  }
</style>
